import { Layout, Text, Box, useLocalVariant } from "@draftkings/arena-web";
import * as React from "react";
export const Reference = React.memo(function Reference(props) {
    const { id, references, testId, children } = props;
    const dot = useLocalVariant("layout", {
        root: {
            display: "inline-block",
            marginRight: "4px",
            marginLeft: "4px",
            width: "2px",
            height: "2px",
            verticalAlign: "middle",
            borderRadius: "100%",
            backgroundColor: "$gray400",
        }
    });
    const referenceVariant = useLocalVariant("layout", {
        root: {
            display: "flex",
            flex: "1 1 auto",
            alignItems: "end",
            fontSize: "10px",
            lineHeight: "16px",
            fontFamily: "Open Sans, sans-serif",
            fontWeight: "400",
        }
    });
    return React.createElement(Layout, { variant: referenceVariant },
        React.createElement(Box, { flex: "1 1 auto", testId: testId }, references.map((reference, index) => React.createElement(React.Fragment, { key: `${id}-${index}` },
            React.createElement(Text, { testId: `${testId}-${id}-${index}`, color: "$gray400", as: "span" }, reference),
            index < references.length - 1 && React.createElement(Layout, { variant: dot })))),
        children);
});
//# sourceMappingURL=Reference.js.map